const TRANSIENT_HTTP_STATUSES = [404, 502, 503, 504];

// Narrow timeout patterns to transport-level timeouts only, avoiding
// false positives from application errors that mention "timeout".
const TIMEOUT_PATTERNS = [
  /timeout exceeded/i,
  /timeout of \d+ms exceeded/i,
  /ETIMEDOUT/i,
  /network timeout/i,
  /request timeout/i
];

export const isTransientServerError = (error: unknown): boolean => {
  const status = (error as { response?: { status?: number } })?.response?.status;
  if (status && TRANSIENT_HTTP_STATUSES.includes(status)) return true;

  const code = (error as { code?: string })?.code;
  if (code === "ECONNABORTED") return true;

  const name = (error as { name?: string })?.name;
  const message = (error as { message?: string })?.message || "";

  if (name === "TypeError" && /Load failed|Failed to fetch/i.test(message)) return true;

  if (TIMEOUT_PATTERNS.some(pattern => pattern.test(message))) return true;

  return false;
};
